import { render, staticRenderFns } from "./ControlProgramPage.vue?vue&type=template&id=5be13ecc&scoped=true&"
import script from "./ControlProgramPage.vue?vue&type=script&lang=js&"
export * from "./ControlProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be13ecc",
  null
  
)

export default component.exports